(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    const chatToggle = root.querySelector('[data-glhk-chat-toggle]');
    const chatPanel = root.querySelector('[data-glhk-chat-panel]');
    let stopChat = () => {};
    if (chatToggle && chatPanel) {
      const closeButton = chatPanel.querySelector('[data-glhk-chat-close]');
      const setChatOpen = (open, restoreFocus = false) => {
        chatPanel.hidden = !open;
        chatToggle.setAttribute('aria-expanded', String(open));
        if (open) {chatPanel.querySelector('.glhk-chat-card').scrollTop = 0;closeButton.focus({preventScroll:true});}
        else if (restoreFocus) chatToggle.focus({preventScroll:true});
      };
      const toggleChat = () => setChatOpen(chatPanel.hidden, !chatPanel.hidden);
      const closeChat = () => setChatOpen(false, true);
      const outsideChat = event => {
        if (!chatPanel.hidden && !chatPanel.contains(event.target) && !chatToggle.contains(event.target)) setChatOpen(false);
      };
      const escapeChat = event => {
        if (chatPanel.hidden) return;
        if (event.key === 'Escape') {event.preventDefault();setChatOpen(false, true);}
        else if (event.key === 'Tab') {
          const controls = [...chatPanel.querySelectorAll('button:not([disabled]), a[href]')].filter(control => control.getClientRects().length > 0);
          const index = controls.indexOf(document.activeElement);
          const next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
          event.preventDefault();controls[next].focus({preventScroll:true});controls[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        }
      };
      chatToggle.addEventListener('click', toggleChat);
      closeButton.addEventListener('click', closeChat);
      document.addEventListener('pointerdown', outsideChat);
      document.addEventListener('keydown', escapeChat);
      stopChat = () => {
        chatToggle.removeEventListener('click', toggleChat);
        closeButton.removeEventListener('click', closeChat);
        document.removeEventListener('pointerdown', outsideChat);
        document.removeEventListener('keydown', escapeChat);
      };
    }

    const toggleComparison = event => {
      const button = event.target.closest('[data-glhk-vs-toggle]');
      if (!button || !root.contains(button)) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel || !root.contains(panel)) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
      button.querySelector('[data-glhk-vs-hint]').textContent = expanded ? button.dataset.less : button.dataset.more;
    };
    root.addEventListener('click', toggleComparison);

    const scrollToReviews = event => {
      const link = event.target.closest('.glhk-hero-rating a[href="#glhk-testi-heading"]');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const destination = root.querySelector('#glhk-testi-heading');
      if (!destination) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      destination.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start'
      });
    };
    root.addEventListener('click', scrollToReviews);

    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    root.querySelector('.glhk-gallery-prev').addEventListener('click', () => show(active - 1));
    root.querySelector('.glhk-gallery-next').addEventListener('click', () => show(active + 1));
    root.querySelector('.glhk-stage').addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const review = root.querySelector('.glhk-review-preview');
    let stopReviews = () => {};
    if (review) {
      const items = [...review.querySelectorAll('[data-review-slot]')];
      const dots = [...review.querySelectorAll('[data-review-dot]')];
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer, visible = false, hovered = false;
      const stop = () => {clearInterval(timer);timer=null;};
      const show = n => {
        index=(n+items.length)%items.length;
        items.forEach((item,i)=>{item.classList.toggle('is-active',i===index);item.setAttribute('aria-hidden',String(i!==index));});
        dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
      };
      const schedule = () => {
        stop();
        if(visible&&!hovered&&!motion.matches&&!document.hidden&&!review.contains(document.activeElement))timer=setInterval(()=>show(index+1),5000);
      };
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);schedule();}));
      review.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));schedule();}});
      review.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;schedule();}});
      review.addEventListener('pointerleave',()=>{hovered=false;schedule();});
      review.addEventListener('focusin',schedule);
      review.addEventListener('focusout',()=>setTimeout(schedule,0));
      document.addEventListener('visibilitychange',schedule);
      motion.addEventListener('change',schedule);
      const inView=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.25});
      inView.observe(review);
      stopReviews=()=>{stop();inView.disconnect();document.removeEventListener('visibilitychange',schedule);motion.removeEventListener('change',schedule);};
    }
    const brand = root.querySelector('.glhk-brand-slider');
    let stopBrand = () => {};
    if (brand) {
      const items = [...brand.querySelectorAll('[data-brand-slide]')];
      const dots = [...brand.querySelectorAll('[data-brand-dot]')];
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer, visible = false, paused = motion.matches, hovered = false;
      const stop = () => { clearInterval(timer); timer = null; };
      const show = n => {
        index = (n + items.length) % items.length;
        items.forEach((item,i) => {item.classList.toggle('is-active',i===index);item.setAttribute('aria-hidden',String(i!==index));});
        dots.forEach((dot,i) => dot.setAttribute('aria-pressed',String(i===index)));
      };
      const schedule = () => {
        stop();
        if (visible && !paused && !hovered && !document.hidden && !brand.contains(document.activeElement)) timer = setInterval(() => show(index+1),5000);
      };
      dots.forEach((dot,i) => dot.addEventListener('click',() => {show(i);schedule();}));
      brand.addEventListener('keydown',event => {if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));schedule();}});
      brand.addEventListener('pointerenter',event => {if(event.pointerType==='mouse'){hovered=true;schedule();}});
      brand.addEventListener('pointerleave',() => {hovered=false;schedule();});
      brand.addEventListener('focusin',schedule);
      brand.addEventListener('focusout',() => setTimeout(schedule,0));
      document.addEventListener('visibilitychange',schedule);
      const onMotion = () => {paused=motion.matches;schedule();};
      motion.addEventListener('change',onMotion);
      const inView = new IntersectionObserver(entries => {visible=entries[0].isIntersecting;schedule();},{threshold:.15});
      inView.observe(brand); schedule();
      stopBrand = () => {stop();inView.disconnect();document.removeEventListener('visibilitychange',schedule);motion.removeEventListener('change',onMotion);};
    }
    const servingVideo = root.querySelector('[data-glhk-serving-video]');
    let stopVideo = () => {};
    if (servingVideo) {
      const playButton = root.querySelector('[data-glhk-video-play]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      servingVideo.muted = true;
      servingVideo.controls = false;
      const sync = () => {
        if (!visible || document.hidden || motion.matches) {
          servingVideo.pause(); playButton.hidden = !motion.matches; return;
        }
        servingVideo.play().then(()=>{playButton.hidden=true;}).catch(()=>{playButton.hidden=false;});
      };
      playButton.addEventListener('click',()=>{servingVideo.play().then(()=>{playButton.hidden=true;}).catch(()=>{servingVideo.controls=true;});});
      const observer = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.2});
      observer.observe(servingVideo);
      document.addEventListener('visibilitychange',sync);
      motion.addEventListener('change',sync);
      stopVideo=()=>{observer.disconnect();servingVideo.pause();document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',sync);};
    }
    const reviewToggle = root.querySelector('.glhk-testi-toggle');
    if (reviewToggle) reviewToggle.addEventListener('click', () => {
      const more = reviewToggle.closest('.glhk-testi-more');
      const extra = more.querySelector('.glhk-testi-extra');
      const opening = reviewToggle.getAttribute('aria-expanded') !== 'true';
      const oldTop = reviewToggle.getBoundingClientRect().top;
      extra.hidden = !opening;
      more.classList.toggle('is-open', opening);
      reviewToggle.setAttribute('aria-expanded', String(opening));
      if (!opening) {
        const newTop = reviewToggle.getBoundingClientRect().top;
        window.scrollBy({top:newTop-oldTop, behavior:'instant'});
      }
    });
    const wall = root.querySelector('.glhk-photo-wall');
    let stopWall = () => {};
    if (wall) {
      const resize = new ResizeObserver(() => { const group = wall.querySelector('.glhk-wall-group'); wall.style.setProperty('--wall-duration', `${group.getBoundingClientRect().width / 48}s`); });
      resize.observe(wall);
      let visible = false;
      const sync = () => wall.classList.toggle('is-visible', visible && !document.hidden);
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();});
      observer.observe(wall);
      document.addEventListener('visibilitychange', sync);
      stopWall = () => {resize.disconnect();observer.disconnect();document.removeEventListener('visibilitychange',sync);};
    }
    const timeline = root.querySelector('#glhk-timeline');
    let stopTimeline = () => {};
    if (timeline) {
      const wrap = timeline.querySelector('.glhk-tl-wrap');
      const rail = timeline.querySelector('.glhk-tl-line');
      const fill = timeline.querySelector('.glhk-tl-fill');
      const items = [...timeline.querySelectorAll('.glhk-tl-item')];
      const mobile = matchMedia('(max-width:899px)');
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!mobile.matches) {rail.style.height = '0px';fill.style.height = '0%';return;}
        const area = wrap.getBoundingClientRect();
        const first = items[0].querySelector('.glhk-tl-rail').getBoundingClientRect();
        const last = items[items.length - 1].getBoundingClientRect();
        const top = first.top - area.top + 10;
        const height = Math.max(0, last.bottom - area.top - 18 - top);
        rail.style.top = `${top}px`;
        rail.style.height = `${height}px`;
        const ratio = height ? Math.max(0, Math.min(1, (innerHeight * .58 - area.top - top) / height)) : 0;
        fill.style.height = `${ratio * 100}%`;
      };
      const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
      const resize = new ResizeObserver(schedule);
      resize.observe(wrap);
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule);
      mobile.addEventListener('change', schedule);
      document.fonts.ready.then(schedule);
      schedule();
      stopTimeline = () => {cancelAnimationFrame(frame);resize.disconnect();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);mobile.removeEventListener('change',schedule);};
    }
    const statsSection = root.querySelector('#glhk-science-stats');
    let stopStats = () => {};
    if (statsSection) {
      const cells = [...statsSection.querySelectorAll('[data-glhk-stat]')];
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let ran = false, frame = 0;
      const formatStat = (c, value) => c.dataset.statSign ? c.dataset.statSign + Math.abs(value).toFixed(Number(c.dataset.statDecimals)) : value.toFixed(Number(c.dataset.statDecimals));
      const showFinal = () => cells.forEach(c => {c.textContent = formatStat(c, Number(c.dataset.glhkStat));});
      const run = () => {
        if (ran) return;
        ran = true;
        if (reduced.matches) {showFinal();return;}
        const start = performance.now();
        const tick = now => {
          const p = Math.min(1, (now - start) / 1200);
          const progress = 1 - Math.pow(1 - p, 3);
          cells.forEach(c => {c.textContent = formatStat(c, Number(c.dataset.glhkStat) * progress);});
          if (p < 1) frame = requestAnimationFrame(tick);else {frame = 0;showFinal();}
        };
        frame = requestAnimationFrame(tick);
      };
      const observer = new IntersectionObserver(entries => {if (entries.some(e=>e.isIntersecting)) {observer.disconnect();run();}}, {threshold:.25});
      observer.observe(statsSection.querySelector('.glhk-stats-grid'));
      const onReduced = () => {if (reduced.matches) {cancelAnimationFrame(frame);frame=0;showFinal();}};
      const onVisibility = () => {if (document.hidden && frame) {cancelAnimationFrame(frame);frame=0;showFinal();}};
      reduced.addEventListener('change',onReduced);
      document.addEventListener('visibilitychange',onVisibility);
      stopStats = () => {cancelAnimationFrame(frame);observer.disconnect();reduced.removeEventListener('change',onReduced);document.removeEventListener('visibilitychange',onVisibility);};
    }
    const researchFaq = root.querySelector('#glhk-faq-3');
    if (researchFaq) {
      root.querySelectorAll('a[href="#glhk-faq-3"]').forEach(link => link.addEventListener('click', () => {researchFaq.open = true;}));
      if (location.hash === '#glhk-faq-3') researchFaq.open = true;
    }
    const form = root.querySelector('#GLHKProductForm');
    const cartLink = root.querySelector('[data-glhk-cart-link]');
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
    if (cartLink && previewTheme && /^\d+$/.test(previewTheme)) {
      const cartURL = new URL(cartLink.href, location.origin);
      cartURL.searchParams.set('preview_theme_id', previewTheme);
      cartLink.href = cartURL.pathname + cartURL.search;
      form.querySelector('[name="return_to"]').value = cartURL.pathname + cartURL.search;
      const trialForm = root.querySelector('.glhk-trial-form');
      if (trialForm) trialForm.querySelector('[name="return_to"]').value = cartURL.pathname + cartURL.search;
    }

    const promotionStart = Date.parse(root.dataset.promotionStart);
    const promotionEnd = Date.parse(root.dataset.promotionEnd);
    const syncPromotion = () => {
      const now = Date.now();
      const active = root.dataset.promotionCurrency === 'HKD' && now >= promotionStart && now < promotionEnd;
      root.querySelectorAll('[data-glhk-promo-visible]').forEach(el => { el.hidden = !active; });
      form.querySelectorAll('[data-promo-eligible]').forEach(radio => {
        const discounted = active && radio.dataset.promoEligible === 'true';
        radio.dataset.price = discounted ? radio.dataset.discountPrice : radio.dataset.regularPrice;
        const card = radio.closest('.glhk-plan');
        card.querySelector('.glhk-plan-price strong').textContent = radio.dataset.price;
        card.querySelector('[data-glhk-average]').textContent = discounted ? radio.dataset.discountAverage : radio.dataset.regularAverage;
        const regular = card.querySelector('[data-glhk-regular-price]');
        if (regular) regular.hidden = !discounted;
      });
    };
    const syncPack = (updateUrl = false) => {
      syncPromotion();
      const radio = form.querySelector('[name="id"]:checked');
      if (!radio) return;
      root.querySelectorAll('[data-glhk-price]').forEach(el => { el.textContent = radio.dataset.price; });
      root.querySelectorAll('[data-glhk-pack-label]').forEach(el => { el.textContent = radio.dataset.packLabel; });
      root.querySelectorAll('[data-glhk-pack-days]').forEach(el => { el.textContent = radio.dataset.packDays; });
      form.querySelector('[name="add"]').disabled = radio.disabled;
      if (updateUrl) {
        const url = new URL(location.href); url.searchParams.set('variant', radio.value);
        history.replaceState(null, '', url);
      }
    };
    form.addEventListener('change', () => syncPack(true));
    let promotionTimer;
    const schedulePromotion = () => {
      clearTimeout(promotionTimer);
      const now = Date.now();
      const boundary = now < promotionStart ? promotionStart : now < promotionEnd ? promotionEnd : null;
      if (boundary !== null) promotionTimer = setTimeout(() => { syncPack(); schedulePromotion(); }, Math.min(boundary - now + 50, 2147483647));
    };
    const restorePack = () => { syncPack(); schedulePromotion(); };
    const restoreVisiblePromotion = () => { if (!document.hidden) restorePack(); };
    document.addEventListener('visibilitychange', restoreVisiblePromotion);
    schedulePromotion();
    window.addEventListener('pageshow', restorePack);
    form.addEventListener('reset', () => requestAnimationFrame(restorePack));
    syncPack();
    const sticky = root.querySelector('.glhk-sticky');
    const stickySize = new ResizeObserver(() => {
      if (!sticky.hidden) root.style.setProperty('--glhk-sticky-height', `${sticky.getBoundingClientRect().height}px`);
    });
    stickySize.observe(sticky);
    const target = root.querySelector('#glhk-buy');
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    }, {threshold:0});
    observer.observe(target);
    const cleanup = event => { if (event.target.contains(root)) { root.removeEventListener('click', toggleComparison); root.removeEventListener('click', scrollToReviews); observer.disconnect(); stickySize.disconnect(); window.removeEventListener('pageshow', restorePack); clearTimeout(promotionTimer); document.removeEventListener('visibilitychange', restoreVisiblePromotion); stopBrand(); stopReviews(); stopVideo(); stopWall(); stopTimeline(); stopStats(); stopChat(); document.removeEventListener('shopify:section:unload', cleanup); } };
    document.addEventListener('shopify:section:unload', cleanup);
  };
  document.querySelectorAll('[data-glhk]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-glhk]').forEach(init));
})();
